import { render, staticRenderFns } from "./LiquidationFilters.vue?vue&type=template&id=2b4cb69d&scoped=true&"
import script from "./LiquidationFilters.vue?vue&type=script&lang=js&"
export * from "./LiquidationFilters.vue?vue&type=script&lang=js&"
import style0 from "./LiquidationFilters.vue?vue&type=style&index=0&id=2b4cb69d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4cb69d",
  null
  
)

export default component.exports